import React from 'react';
import { primaryWhiteLogo } from 'Utils/utilsStyle';

type Props = {
  className?: string
};
const defaultProps = {
  className: '',
};
const PrimaryWhiteLogo = function (props: Props) {
  return (
    <img src={`${primaryWhiteLogo}`} alt="logo" {...props} />
  );
};

PrimaryWhiteLogo.defaultProps = defaultProps;
export default PrimaryWhiteLogo;
